// extracted by mini-css-extract-plugin
module.exports = {"inner":"ErrorPage_inner__vGvwP","heading":"ErrorPage_heading__ibesr"};